import Icon from '../components/Icon.vue'

Icon.register({"window-restore":{"width":2048,"height":1792,"paths":[{"d":"M256 1536h768v-512h-768v512zM1280 1024h512v-768h-768v256h96q66 0 113 47t47 113v352zM2048 160v960q0 66-47 113t-113 47h-608v352q0 66-47 113t-113 47h-960q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h608v-352q0-66 47-113t113-47h960q66 0 113 47t47 113z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/window-restore.js